import { render, staticRenderFns } from "./jobCard.vue?vue&type=template&id=79c95108&scoped=true"
import script from "./jobCard.vue?vue&type=script&lang=js"
export * from "./jobCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c95108",
  null
  
)

export default component.exports